// extracted by mini-css-extract-plugin
export default {"wrapper":"PricingTable_wrapper__7jC2D","note":"PricingTable_note__5PRUV","fadeIn":"PricingTable_fadeIn__y66Z2"};